import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { CLIENT_SETTING, CONTENT_HUB_API } from "../../constants/APIs";
import { genericApiSaga, getRequest, putRequest } from "../../services/api";
import * as actions from "../actions";
import {
  fetchGalleryTypes,
  galleryVotingTypes,
  getClientSettingTypes,
  trackContentViewTypes,
} from "./gallery.types";

export function* getClientSetting({ payload }) {
  const metadata = {
    apiUrl: CLIENT_SETTING,
    customHeaders: {
      "x-client-id": payload.clientId,
    },
  };
  yield genericApiSaga({
    gatewayCall: () => getRequest({ ...metadata }),
    *completed(response) {
      yield put(actions.getClientSettingSucceeded(response));
    },
    *failed(response) {
      yield put(actions.getClientSettingFailed(response));
    },
  });
}

export function* galleryVoting({ payload }) {
  const { clientId, contentId, unVote = false } = payload || {};
  const metadata = {
    apiUrl: `${CONTENT_HUB_API}/${clientId}/${contentId}/vote?unVote=${unVote}`,
    customHeaders: {
      "x-client-id": clientId,
    },
  };
  yield genericApiSaga({
    gatewayCall: () => putRequest({ ...metadata }),
    *completed(response) {
      yield put(actions.galleryVotingSucceeded(response));
    },
    *failed(response) {
      yield put(actions.galleryVotingFailed(response));
    },
  });
}

export function* trackContentView({ payload }) {
  const { clientId, contentId } = payload;
  const metadata = {
    apiUrl: `${CONTENT_HUB_API}/${clientId}/${contentId}/view`,
    customHeaders: {
      "x-client-id": clientId,
    },
  };
  yield genericApiSaga({
    gatewayCall: () => putRequest({ ...metadata }),
    *completed(response) {
      yield put(actions.trackContentViewSucceeded(response));
    },
    *failed(response) {
      yield put(actions.trackContentViewFailed(response));
    },
  });
}

export function* fetchGallery({ payload }) {
  const { clientId, galleryId, sort, sortDirection } = payload;
  const metadata = {
    apiUrl: `${CONTENT_HUB_API}/${clientId}/${galleryId}?sort=${sort}&sortDirection=${sortDirection}`,
    customHeaders: {
      "x-client-id": clientId,
    },
  };
  yield genericApiSaga({
    gatewayCall: () => getRequest({ ...metadata }),
    *completed(response) {
      yield put(actions.fetchGallerySucceeded(response));
    },
    *failed(response) {
      yield put(actions.fetchGalleryFailed(response));
    },
  });
}

export function* watcherGallerySaga() {
  yield takeLatest(
    getClientSettingTypes.GET_CLIENT_SETTING_REQUEST,
    getClientSetting
  );
  yield takeLatest(galleryVotingTypes.GALLERY_VOTING_REQUEST, galleryVoting);
  yield takeLatest(
    trackContentViewTypes.TRACK_CONTENT_VIEW_REQUEST,
    trackContentView
  );
  yield takeLatest(fetchGalleryTypes.FETCH_GALLERY_REQUEST, fetchGallery);
}
